/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsDtoSpirisInvoiceRowDto } from './WebApiIntegrationsDtoSpirisInvoiceRowDto';
import {
    WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSON,
    WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSONTyped,
    WebApiIntegrationsDtoSpirisInvoiceRowDtoToJSON,
} from './WebApiIntegrationsDtoSpirisInvoiceRowDto';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoCreateSpirisInvoiceDto
 */
export interface WebApiIntegrationsDtoCreateSpirisInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateSpirisInvoiceDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateSpirisInvoiceDto
     */
    memberId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateSpirisInvoiceDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateSpirisInvoiceDto
     */
    connectedYear?: string | null;
    /**
     * Optional Spiris article for the legacy single row.
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateSpirisInvoiceDto
     */
    articleNumber?: string | null;
    /**
     * Optional invoice due date. Null => Spiris default.
     * @type {Date}
     * @memberof WebApiIntegrationsDtoCreateSpirisInvoiceDto
     */
    dueDate?: Date | null;
    /**
     * Optional invoice date. Null => today.
     * @type {Date}
     * @memberof WebApiIntegrationsDtoCreateSpirisInvoiceDto
     */
    invoiceDate?: Date | null;
    /**
     * Invoice lines. When non-empty this is used and the scalar description /
     * amount / ArticleNumber are ignored. Those scalars are
     * the legacy single-line form.
     * @type {Array<WebApiIntegrationsDtoSpirisInvoiceRowDto>}
     * @memberof WebApiIntegrationsDtoCreateSpirisInvoiceDto
     */
    rows?: Array<WebApiIntegrationsDtoSpirisInvoiceRowDto> | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreateSpirisInvoiceDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreateSpirisInvoiceDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreateSpirisInvoiceDtoFromJSON(json: any): WebApiIntegrationsDtoCreateSpirisInvoiceDto {
    return WebApiIntegrationsDtoCreateSpirisInvoiceDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreateSpirisInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreateSpirisInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
        'dueDate': !exists(json, 'dueDate') ? undefined : (json['dueDate'] === null ? null : new Date(json['dueDate'])),
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : (json['invoiceDate'] === null ? null : new Date(json['invoiceDate'])),
        'rows': !exists(json, 'rows') ? undefined : (json['rows'] === null ? null : (json['rows'] as Array<any>).map(WebApiIntegrationsDtoSpirisInvoiceRowDtoFromJSON)),
    };
}

export function WebApiIntegrationsDtoCreateSpirisInvoiceDtoToJSON(value?: WebApiIntegrationsDtoCreateSpirisInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'memberId': value.memberId,
        'amount': value.amount,
        'connectedYear': value.connectedYear,
        'articleNumber': value.articleNumber,
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
        'invoiceDate': value.invoiceDate === undefined ? undefined : (value.invoiceDate === null ? null : value.invoiceDate.toISOString()),
        'rows': value.rows === undefined ? undefined : (value.rows === null ? null : (value.rows as Array<any>).map(WebApiIntegrationsDtoSpirisInvoiceRowDtoToJSON)),
    };
}

